"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = _interopRequireDefault(require("./constants"));
var _webClientStore = require("web-client-store");
var _ApiHandler = _interopRequireDefault(require("./ApiHandler"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // import ApiHandler from './ApiHandler';
let {
  Indexed
} = _webClientStore.WebClientStore;
let {
  URLs,
  INDEXED_KEYS,
  getDomain
} = _constants.default;
class AccountHandler extends _ApiHandler.default {
  constructor() {
    super(...arguments);
    _defineProperty(this, "baseUrl", URLs.ACCOUNTS);
    _defineProperty(this, "fetchAccounts", async acId => {
      let url = this.baseUrl + (acId ? '/' + acId : '');
      let response = await this.standardGetOperation(url);
      let accounts = response.data;
      if (acId) {
        return Promise.resolve(accounts);
      } else {
        return Promise.resolve(accounts.sort(_constants.default.SortBy('name')));
      }
    });
    _defineProperty(this, "fetchAccount", acId => this.fetchAccounts(acId));
    _defineProperty(this, "getAccountTrans", async acId => {
      let url = URLs.TRANS_OF_ACCOUNT + "/" + acId;
      if (this.store.Session.get(acId + '_req_ts')) {
        url += '?request=' + this.store.Session.get(acId + '_req_ts');
        this.store.Session.unset(acId + '_req_ts');
      }
      let response = await this.standardGetOperation(url);
      return Promise.resolve(response.data);
    });
    _defineProperty(this, "getAccountMembers", async acId => {
      let url = URLs.ACCOUNT_MEMBERS + "/ac/" + acId;
      let response = await this.standardGetOperation(url);
      return Promise.resolve(response.data);
    });
    _defineProperty(this, "getAccountSubscribers", async acId => {
      let url = URLs.ACCOUNT_SUBSCRIBERS + "/ac/" + acId;
      let response = await this.standardGetOperation(url);
      return Promise.resolve(response.data);
    });
  }
  startTheChit(acId) {
    let url = "".concat(this.baseUrl, "/").concat(acId);
    return new Promise((resolve, reject) => {
      this.getInstance().patch(url, {
        startChitFlag: true
      }).then(account => {
        //this.showSuccess(`Chitfund started successfully.`);
        resolve(account);
      }).catch(err => this.handleError(err, "Error while starting chitfund. Try again."));
    });
  }
  updateSubscriberDetails(acId, index, data) {
    return new Promise((resolve, reject) => {
      this.getInstance().patch(URLs.ACCOUNT_SUBSCRIBERS + '/ac/' + acId + '/subscriber/id/' + index, data).then(response => {
        //this.showSuccess('Subscriber info updated successfully.')
        resolve(true);
      }).catch(err => {
        reject(err);
      });
    });
  }
  postNewChitTerm(acId, payload) {
    let url = "".concat(URLs.TRANS, "/newchitterm/ac/").concat(acId);
    return new Promise((resolve, reject) => {
      this.getInstance().post(url, payload).then(response => {
        //this.showSuccess(response.data.message);
        resolve(response);
      }).catch(err => this.handleError(err, "Error while posting chit term. Try again."));
    });
  }
  patchAccountStatus(acId, status) {
    let hooks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // let msg = status === 'cl' ? `Account archived successfully.` : 
    //                             `Account re-activated successfully.`;
    let url = "".concat(this.baseUrl, "/").concat(acId);
    if (hooks && hooks.before) hooks.before();
    return new Promise((resolve, reject) => {
      this.getInstance().patch(url, {
        status
      }).then(account => {
        // //this.showSuccess(msg);
        if (hooks && hooks.after) hooks.after();
        resolve(account);
      }).catch(err => this.handleError(err, "Error while archiving account. Try again."));
    });
  }
  unArchiveAccount(acId) {
    let hooks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this.patchAccountStatus(acId, 'ac', hooks);
  }
  archiveAccount(acId) {
    let hooks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this.patchAccountStatus(acId, 'cl', hooks);
  }
  deleteAccount() {
    let ac = this.getActiveAccount();
    if (!ac) {
      //this.showWarn('Please select an account to delete.');
      return;
    }
    //this.nav.showOverlay();
    /* call archive signature */
    this.archiveAccount(ac).finally(() => {
      //this.nav.hideOverlay(); 
      //this.nav.closeModal(); 
      //this.nav.reloadToAccounts()
    });
  }
  getAccountsCached() {
    let unset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return this.cachedResponse(unset, INDEXED_KEYS.ACCOUNTS, this.fetchAccounts);
  }
  getAccountCached(acId) {
    let unset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return this.getAccountsCached(unset).then(accounts => {
      return accounts.filter(ac => ac._id === acId)[0];
    });
  }
  getAccountTransCached(acId) {
    let unset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return this.cachedResponse(unset, INDEXED_KEYS.ACCOUNT_TRANSACTIONS + "_" + acId, this.getAccountTrans, [acId]);
  }
  getAccountSubscribersCached(acId) {
    let unset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return this.cachedResponse(unset, INDEXED_KEYS.ACCOUNT_SUBSCRIBERS + "_" + acId, this.getAccountSubscribers, [acId]);
  }
  getUserRoles(acId, acUid) {
    return new Promise((resolve, reject) => {
      let _roles = {
        owner: false,
        admin: false,
        editor: false,
        viewer: false,
        any: false
      };
      this.getAccountMembers(acId).then(async members => {
        let currentUser = await Indexed.getAsync(INDEXED_KEYS.USER_INFO);
        _roles.admin = acUid === currentUser.id;
        let _members = members.filter(member => {
          return member.uid === currentUser.id && member.status === 'ac';
        });
        if (Array.isArray(_members) && _members.length > 0) {
          _roles.admin = _members[0].role === 'admin';
          _roles.editor = _members[0].role === 'editor';
          _roles.viewer = _members[0].role === 'viewer';
          _roles.any = _roles.admin || _roles.editor || _roles.viewer;
        }
        resolve(_roles);
      });
    });
  }
  deleteAccountMember(acId, memId) {
    return new Promise((resolve, reject) => {
      let retrieveFrom = "".concat(URLs.ACCOUNT_MEMBERS, "/ac/").concat(acId, "/member/").concat(memId);
      this.getInstance().delete(retrieveFrom).then(() => {
        //this.showSuccess('Member deleted successfully.')
        resolve('');
      }).catch(error => this.handleError('Error: Could not be delete member. Try again'));
    });
  }
  /*
  }
  class AccountChitHandler extends ApiHandler {
   constructor(callerComponent) {
      super(callerComponent);
      this.comp = callerComponent;
  }
  */
  addDummySubscribers(accId) {
    let url = URLs.ACCOUNT_SUBSCRIBERS + "/ac/" + accId + "/add/dummy";
    let payload = {};
    return new Promise((resolve, reject) => {
      this.getInstance().post(url, payload).then(response => {
        //this.showSuccess(`Default subscribers added successfully.`)
        resolve(response);
      }).catch(err => this.handleError(err, "Error while adding subscribers to account."));
    });
  }
  createContributor(contributor) {
    let ac = this.getActiveAccount();
    if (!ac) {
      //this.showWarn('Please select an account to add subscriber.');
      return;
    }
    // let contributor = this.comp.state.contributor;
    let member = this.prepareObjectForSaving(contributor);
    let url = URLs.ACCOUNT_MEMBERS + "/ac/" + ac + "/add/email";
    let payload = {
      "domain": getDomain(),
      "name": member.name,
      "email": member.email,
      "role": member.role || 'viewer',
      "status": member.status || 'ac'
    };
    //this.nav.setActionInProgress();
    return new Promise((resolve, reject) => {
      this.getInstance().post(url, payload).then(response => {
        //this.showSuccess(`Member invited successfully.`)
        //this.nav.unsetActionInProgress();
        resolve(response);
      }).catch(err => {
        //this.nav.unsetActionInProgress();
        this.handleError(err, "Error while adding member to account.");
      });
      //.finally(()=>this.comp.props.onSubmit())
    });
  }
}
exports.default = AccountHandler;